module.exports = __webpack_public_path__ + "img/gq.4865d05d.svg";